import { Button, ButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const CancelButton = styled(Button)<ButtonProps>(({ theme }) => ({
  marginLeft:"10px",
  marginRight:"10px",
  borderRadius:"4px", 
  backgroundColor: "#9d9d9d", 
  padding: "8px 30px", 
  color: "#ffffff", 
  fontFamily: "Roboto, 'Noto Sans', sans-serif", 
  "&:hover": { backgroundColor: "#b2b1b1" },
  "&.Mui-disabled": {
    border: "1px solid rgba(0,0,0,0.12)",
    color: "rgba(0,0,0,0.26)",
    backgroundColor: "#FFFFFF"
  }
}));

export default CancelButton;